import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-600 via-amber-600 to-orange-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        {/* Icon */}
        <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <i className="ri-rocket-2-line text-5xl text-white"></i>
        </div>

        {/* Heading */}
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to Transform How You Find Work?
        </h2>
        <p className="text-xl text-orange-100 mb-10 max-w-3xl mx-auto leading-relaxed">
          Join thousands of Australian tradies already using AI to find better jobs faster. Or post your first job and get quotes from qualified professionals in minutes.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <Link
            to="/signup"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-10 py-4 rounded-lg font-bold hover:bg-orange-50 transition-all shadow-xl hover:shadow-2xl text-lg whitespace-nowrap cursor-pointer"
          >
            <span>Join as Tradie</span>
            <i className="ri-user-add-line"></i>
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-orange-800 text-white px-10 py-4 rounded-lg font-bold hover:bg-orange-900 transition-all shadow-xl hover:shadow-2xl text-lg whitespace-nowrap cursor-pointer"
          >
            <span>Post a Job</span>
            <i className="ri-add-circle-line"></i>
          </Link>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-8 text-white/90">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-2xl"></i>
            <span className="font-medium">Free to Join</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-2xl"></i>
            <span className="font-medium">No Credit Card Required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-2xl"></i>
            <span className="font-medium">Start Finding Jobs Today</span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-3 gap-8 mt-16 pt-12 border-t border-white/20">
          <div>
            <div className="text-4xl font-bold text-white mb-2">2,400+</div>
            <div className="text-orange-100">Active Jobs</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2">8,500+</div>
            <div className="text-orange-100">Registered Tradies</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2">$8.2M</div>
            <div className="text-orange-100">Jobs Completed</div>
          </div>
        </div>
      </div>
    </section>
  );
}